export default "__VITE_ASSET__DQh48t$p__"